module.exports = __webpack_public_path__ + "static/drumster-footerBanner@2x-min-a847eabd086ca1e708aefd7cc2d3878e.png";